import { useDispatch } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import { SIGN_OUT } from 'constants/popups';
import { openPopup } from 'store/actions';
import UserAvatar from 'sections/userAvatar';

import { menuItems } from './config';

import bigLogo from 'assets/images/big-logo.svg';
import teamLogo from 'assets/images/team-logo.png';
import logoGame from 'assets/images/gamedaddy.svg';

function Menu({ isOpen, onItemClick }) {
  const dispatch = useDispatch();

  return (
    isOpen && (
      <div className={'open-nav-holder active'}>
        <div className="scroll-holder">
          <div className="scroll-container">
            <div className="sub-nav-header">
              <div className="medium-logo">
                <img src={bigLogo} alt="big logo" />
              </div>
              <Link to="/user-profile" onClick={onItemClick}>
                <div className="avatar-contain">
                  <UserAvatar />
                  <div className="team-logo-holder">
                    <img src={teamLogo} alt="team logo" />
                  </div>
                </div>
              </Link>
            </div>
            <div className="sub-nav-list-holder">
              {menuItems.map(({ name, link, iconName }) => (
                <NavLink
                  to={link}
                  key={name}
                  className="sub-nav-item"
                  activeClassName="active"
                  onClick={onItemClick}
                >
                  <i className={iconName} />
                  <span>{name}</span>
                </NavLink>
              ))}
            </div>
            <div className="second-sub-list">
              <NavLink
                to="#"
                className="sub-nav-item"
                onClick={() => {
                  dispatch(openPopup(SIGN_OUT));
                }}
              >
                <i className="icon-log-out" />
                <span>Log out</span>
              </NavLink>
              <NavLink
                to="/user-profile"
                onClick={onItemClick}
                className="sub-nav-item ico-p-r"
              >
                <span>Settings And Privacy</span>
              </NavLink>
              <NavLink to="/help" onClick={onItemClick} className="sub-nav-item ico-p-r">
                <span>Help Center</span>
              </NavLink>
              <NavLink to="#" onClick={onItemClick} className="sub-nav-item ico-p-r">
                <img src={logoGame} alt="logo game" />
                <i className="icon-hand-history" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default Menu;
